<template>
  <a-layout :class="['layout', device]">
    <!-- SideMenu -->
    <a-drawer
      v-if="isMobile()"
      placement="left"
      :wrapClassName="`drawer-sider ${navTheme}`"
      :closable="false"
      :visible="collapsed"
      @close="drawerClose"
    >
      <side-menu
        mode="inline"
        :menus="menus"
        :theme="navTheme"
        :collapsed="false"
        :collapsible="true"
        @menuSelect="menuSelect"
      ></side-menu>
    </a-drawer>

    <side-menu
      v-else-if="isSideMenu()"
      mode="inline"
      :menus="menus"
      :theme="navTheme"
      :collapsed="collapsed"
      :collapsible="true"
    ></side-menu>

    <a-layout
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }"
    >
      <!-- layout header -->
      <global-header
        :mode="layoutMode"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      />

      <!-- layout content -->
      <a-layout-content
        :style="{
          height: '100%',
          margin: multiTab ? '24px 24px 0' : '24px 24px 0',
          paddingTop: fixedHeader ? '64px' : '0',
        }"
      >
        <multi-tab v-if="multiTab"></multi-tab>
        <transition name="page-transition">
          <route-view />
        </transition>
      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer>
        <global-footer />
      </a-layout-footer>

      <!-- Setting Drawer (show in development mode) -->
      <setting-drawer></setting-drawer>
      <!-- 任务监控 Drawer -->
      <task-drawer></task-drawer>
      <!-- 客服聊天 -->
      <customer-service-drawer></customer-service-drawer>
      <!-- 演示视频组件 -->
      <demo-video></demo-video>
      <!-- 谷歌验证组件 -->
      <google-auth-modal></google-auth-modal>
    </a-layout>
  </a-layout>
</template>

<script>
import { triggerWindowResizeEvent } from '@/utils/util'
import { mapState, mapActions } from 'vuex'
import { mixin, mixinDevice } from '@/utils/mixin'
import config from '@/config/defaultSettings'
import axios from 'axios'
import RouteView from './RouteView'
import MultiTab from '@/components/MultiTab'
import SideMenu from '@/components/Menu/SideMenu'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import SettingDrawer from '@/components/SettingDrawer'
import TaskDrawer from '@/views/components/TaskDrawer'
import CustomerServiceDrawer from '@/views/components/CustomerServiceDrawer'
import DemoVideo from '@/views/components/demo/DemoVideo'
import GoogleAuthModal from '@/views/components/GoogleAuthModal'

export default {
  name: 'BasicLayout',
  mixins: [mixin, mixinDevice],
  components: {
    RouteView,
    MultiTab,
    SideMenu,
    GlobalHeader,
    GlobalFooter,
    SettingDrawer,
    TaskDrawer,
    DemoVideo,
    GoogleAuthModal,
    CustomerServiceDrawer,
  },
  data() {
    return {
      production: config.production,
      collapsed: false,
      menus: [],
      notice: '',
      disabled: true,
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.addRouters,
    }),
    contentPaddingLeft() {
      if (!this.fixSidebar || this.isMobile()) {
        return '0'
      }
      if (this.sidebarOpened) {
        return '256px'
      }
      return '80px'
    },
    spread() {
      return this.$store.state.brand.spread
    },
  },
  watch: {
    sidebarOpened(val) {
      this.collapsed = !val
    },
  },
  created() {
    this.$connect() //连接websocket
    this.menus = this.mainMenu.find(item => item.path === '/').children
    this.collapsed = !this.sidebarOpened
    // this.openNotice()
    if (process.env.NODE_ENV !== 'development') {
      this.getNotice()
    }
  },
  mounted() {
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }
  },
  methods: {
    ...mapActions(['setSidebar']),
    toggle() {
      this.collapsed = !this.collapsed
      this.setSidebar(!this.collapsed)
      triggerWindowResizeEvent()
    },
    paddingCalc() {
      let left = ''
      if (this.sidebarOpened) {
        left = this.isDesktop() ? '256px' : '80px'
      } else {
        left = (this.isMobile() && '0') || (this.fixSidebar && '80px') || '0'
      }
      return left
    },
    menuSelect() {
      if (!this.isDesktop()) {
        this.collapsed = false
      }
    },
    drawerClose() {
      this.collapsed = false
    },
    openNotification() {
      // this.$notification.open({
      //   message: '通知公告',
      //   description: '从下周一（10月14日）起，新增机器人赠送的免费期限将从30天调整为7天！感谢您的使用，我们将持续提供行业最优质的服务。',
      //   icon: <a-icon type="smile" style="color: #108ee9" />,
      //   duration: 60
      // });
    },
    getNotice() {
      const service = axios.create({
        // baseURL: 'http://service-fxnxkjgn-1301483065.sh.apigw.tencentcs.com:80/', // api base_url
        baseURL: 'https://notice.nianchu.net/', // api base_url

        timeout: 100000, // 请求超时时间
      })
      service({
        url: '/getNotice',
        method: 'get',
        params: {
          type: 1,
        },
      }).then(res => {
        const body = JSON.parse(res.data.body)
        if (body) {
          if (body.code == 0) {
            this.notice = body.data.context
            this.openNotice()
          } else {
            this.$message.error('公告获取失败3')
          }
        } else {
          this.$message.error('公告获取失败1')
        }
      })
    },
    openNotice() {
      if (!this.spread) {
        return false
      }
      let secondsToGo = 5
      const h = this.$createElement
      const modal = this.$info({
        title: '系统公告',
        width: 800,
        okButtonProps: {
          props: {
            disabled: this.disabled,
          },
        },
        okText: secondsToGo + 's后',
        content: h('div', {}, [
          h('div', {
            domProps: {
              innerHTML: this.notice,
              // `
              // <p>个人版客户端最新版本更新内容：</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.优化联盟授权检测逻辑，减少内存资源占用</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查券记录有效期更改为10小时，减少特殊运营场景下，订单促绑和不绑定情况</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.优化黑名单用户标记逻辑，修复偶发情况下机器人主动发消息给黑名单用户的情况</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.修复上版本促单消息设置时长问题，请及时修改</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.运营者消息通知优化，云感知，管理员，钉钉，同步通知</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.调整机器人客户端扩展配置选项，请到控制台-更多功能-拓展配置页面，支持一键推送，使用红包推送进群，群邀请绑定功能的小伙伴，请及时推送配置，默认只开启查券追单，和禁用比价！</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7.增加兜底回复功能，当机器人无法给出答复时，使用兜底消息默认回复用户</p>
              //             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8.增加拼多多比价订单返回cms商城开关，机器人检测到比价后，自动推送商城，插件-查券-佣金对比方案中开启</p>
              //             `
            },
          }),
        ]),
        onOk() {},
      })
      const interval = setInterval(() => {
        secondsToGo -= 1
        modal.update({
          okText: secondsToGo + 's后',
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        this.disabled = false
        modal.update({
          okText: '知道了',
          okButtonProps: {
            props: {
              disabled: this.disabled,
            },
          },
        })
      }, secondsToGo * 1000)
    },
  },
}
</script>

<style lang="less">
@import url('../components/global.less');

/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
